import Item from './model';
import create from './create';

Item.create = create;

export default Item;



// WEBPACK FOOTER //
// ./data/WritingAssignment/ShortAnswer/model/Item/index.js